<template>
    <div>
        <b-row class="toolbar-ptc">
            <b-col>
                <router-link :to="{ name: 'member_info_list', params: { search:$route.params.search } }" class="btn btn-ptc1" tag="button">返回</router-link>
            </b-col>
            <b-col class="text-center title">會員管理 / 會員查詢 / 累點紀錄({{this.$route.params.membername}})</b-col>
            <b-col>
                <div class="text-right">
                    <b-btn class="btn btn-ptc1" v-b-toggle.collapse1>查詢</b-btn>
                </div>
            </b-col>
        </b-row>
        <div id="func-content">
            <b-collapse id="collapse1" class="mt-2" style="margin-bottom: 10px;">
                <b-card class="bg-default-card">
                    <div class="row">
                        <div class="col-lg-12">
                            <div class="p-4 box-shadow" header="Form Elements">
                                <div class="row">
                                  <!-- 新增品牌下拉選單 -->
                                  <label class="control-label col-md-2">品牌：</label>
                                    <div class="col-md-3">
                                        <select
                                          id="queryBrandsCode"
                                          name="queryBrandsCode"
                                          class="form-control"
                                          v-model="model.queryBrandsCode"
                                        >
                                        <option
                                          v-for="x in selectListBrands"
                                          v-bind:value="x.Code"
                                          :key="x.Code"
                                        >{{x.Text}}</option>
                                        </select>
                                    </div>
                                </div>
                                  <div class="row mt-3">
                                    <label class="col-md-2 control-label" for="example-select">點數類別:</label>
                                    <div class="col-md-3">
                                        <select id="example-select" name="example-select" class="form-control" v-model="model.types" size="1">
                                            <option value="0">
                                                全部
                                            </option>
                                            <option v-for="v in mergedTransactionTypes" :key="v.Code" :value="v.Code">
                                              {{ v.Text }}
                                            </option>
                                        </select>
                                    </div>
                                </div>
                                <div class="row mt-3">
                                    <label class="control-label col-md-2">累點時間區間：</label>
                                    <div class="col-md-3">
                                        <input type="date" class="form-control" v-model="model.sdate" max="9999-12-31" @input="changeDate($event, 1)" v-on:keydown="keydownDate($event, 1)">
                                    </div>
                                    <label class="control-label">至</label>
                                    <div class="col-md-3">
                                        <input type="date" class="form-control" v-model="model.edate" max="9999-12-31" @input="changeDate($event, 2)" v-on:keydown="keydownDate($event, 2)">
                                    </div>
                                    <div class="col-md-3">
                                        <button type="button" class="btn btn-warning text-white " @click="search()">查詢</button>
                                        <button type="reset" class="btn btn-warning text-white" @click="reset()">重設</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </b-card>
            </b-collapse>
            <!-- First Basic Table Ends Here-->
            <!-- Second Data Table Starts Here-->
            <div class="row">
                <div class="col-lg-12 mb-3">
                    <b-card class="bg-default-card">
                        <div class="row">
                            <div class="col-lg-12">
                                <div class="p-4 box-shadow" header="Form Elements">
                                    <div class="row col-lg-12">
                                        <label class="control-label">可用點數：{{model.TotalPoint}}</label>
                                    </div>
                                    <div class="table-responsive">
                                        <table id="mytable" class="table table-bordred table-striped">
                                            <thead v-if="!isMergedSelected">
                                              <tr>
                                                  <th>品牌</th>
                                                  <th>點數類型</th>
                                                  <th>累點時間</th>
                                                  <th>交易門市</th>
                                                  <th>交易總金額</th>
                                                  <th>交易點數</th>
                                                  <th>總點數</th>
                                              </tr>
                                            </thead>
                                            <tbody>
                                                <!-- 合併模式：固定顯示巢狀內容 -->
                                                <template v-if="isMergedSelected">
                                                    <!-- 父列（摘要） -->
                                                    <tr class="table-active">
                                                        <td colspan="7">
                                                            <strong class="ml-1">線下點餐-點數折抵</strong>
                                                            <div class="ml-2 text-muted">
                                                              目前顯示 {{ preholdRows.length + confirmRows.length }} 筆
                                                              （預扣 {{ preholdRows.length }}、確認 {{ confirmRows.length }}）
                                                            </div>
                                                        </td>
                                                    </tr>

                                                    <!-- 子列：固定顯示巢狀 -->
                                                    <tr>
                                                        <td colspan="7" style="background:#fafafa">
                                                            <!-- 子區塊：預扣 T4 -->
                                                            <div class="mb-3">
                                                                <div class="font-weight-bold mb-2">線下點餐-點數折抵（預扣）</div>
                                                                <table class="table table-sm">
                                                                    <thead>
                                                                    <tr>
                                                                        <th>品牌</th>
                                                                        <th>點數類型</th>
                                                                        <th>累點時間</th>
                                                                        <th>交易門市</th>
                                                                        <th>交易總金額</th>
                                                                        <th>交易點數</th>
                                                                        <th>總點數</th>
                                                                    </tr>
                                                                    </thead>

                                                                    <tbody>
                                                                      <tr v-for="(v, i) in preholdRows" :key="'t4-'+i">
                                                                          <td>{{ brandName(v.BrandCode) }}</td>
                                                                          <td>線下點餐-點數折抵（預扣）</td>
                                                                          <td>{{ v.TransactionAt | formatDate }}</td>
                                                                          <td>{{ v.StoreName }}</td>
                                                                          <td>{{ v.TransactionAmount }}</td>
                                                                          <td>{{ v.Bonus }}</td>
                                                                          <td>{{ v.TotalBonus }}</td>
                                                                      </tr>
                                                                      <tr v-if="preholdRows.length === 0">
                                                                          <td colspan="7" class="text-center text-muted">無資料</td>
                                                                      </tr>
                                                                    </tbody>
                                                                </table>
                                                            </div>

                                                            <!-- 子區塊：確認 T6 -->
                                                            <div>
                                                                <div class="font-weight-bold mb-2">線下點餐-點數折抵（確認）</div>
                                                                <table class="table table-sm">
                                                                    <thead>
                                                                        <tr>
                                                                            <th>品牌</th>
                                                                            <th>點數類型</th>
                                                                            <th>累點時間</th>
                                                                            <th>交易門市</th>
                                                                            <th>交易總金額</th>
                                                                            <th>交易點數</th>
                                                                            <th>總點數</th>
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                        <tr v-for="(v, i) in confirmRows" :key="'t6-'+i">
                                                                            <td>{{ brandName(v.BrandCode) }}</td>
                                                                            <td>線下點餐-點數折抵（確認）</td>
                                                                            <td>{{ v.TransactionAt | formatDate }}</td>
                                                                            <td>{{ v.StoreName }}</td>
                                                                            <td>{{ v.TransactionAmount }}</td>
                                                                            <td>{{ v.Bonus }}</td>
                                                                            <td>{{ v.TotalBonus }}</td>
                                                                        </tr>
                                                                        <tr v-if="confirmRows.length === 0">
                                                                            <td colspan="7" class="text-center text-muted">無資料</td>
                                                                        </tr>
                                                                    </tbody>
                                                                </table>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                </template>

                                                <!-- 非合併模式：照舊顯示分頁資料 -->
                                                <template v-else>
                                                    <tr v-for="v in pagedRows" :key="v.id">
                                                        <td>{{ brandName(v.BrandCode) }}</td>
                                                        <td>
                                                            {{
                                                                (v.TransactionType==='T1') ? '交易-消費累點' :
                                                                (v.TransactionType==='T2') ? '退貨-退貨扣點' :
                                                                (v.TransactionType==='T4') ? '線下點餐-點數折抵（預扣）' :
                                                                (v.TransactionType==='T5') ? '取消點數折抵' :
                                                                (v.TransactionType==='T6') ? '線下點餐-點數折抵（確認）' :
                                                                (v.TransactionType==='T7') ? 'POS退還票券' :
                                                                (v.TransactionType==='O1') ? '線上點餐-消費累點' :
                                                                (v.TransactionType==='O2') ? '線上點餐-退貨扣點' :
                                                                (v.TransactionType==='O3') ? '線上點餐-退貨用券返點' :
                                                                (v.TransactionType==='O4') ? '線上點餐-點抵金' :
                                                                (v.TransactionType==='O5') ? '線上點餐-取消點抵金' :
                                                                (v.TransactionType==='O6') ? '線上訂單取消-退還票券' :
                                                                (v.TransactionType === 'E2') ? '退貨-行銷活動扣點' + ((v.EventTitle !== '') ? '(' + v.EventTitle + ')' : '' ) :
                                                                (v.TransactionType === 'E1') ? '行銷活動' + ((v.EventTitle !== '') ? '(' + v.EventTitle + ')' : '' ) :
                                                                (v.TransactionType === 'M1') ? '補點-特殊補點' :
                                                                (v.TransactionType === 'M2') ? '補點-舊系統會員補點' :
                                                                (v.TransactionType === 'A1') ? '升級-活動累點' :
                                                                (v.TransactionType === 'A3') ? '推薦好友-活動累點(推薦好友)' :
                                                                (v.TransactionType === 'A5') ? '生日禮-活動累點(生日禮)' :
                                                                (v.TransactionType === 'A7') ? '推薦好友-活動累點(被推薦)' :
                                                                (v.TransactionType === 'A8') ? '點數回饋-問卷禮' :
                                                                (v.TransactionType === 'C1') ? '兌換電子券' :
                                                                (v.TransactionType === 'P1') ? '點數到期失效' :
                                                                (v.TransactionType === 'G1') ? '贈卷活動' :
                                                                (v.TransactionType === 'G2') ? '點數轉贈' :
                                                                (v.TransactionType === 'G3') ? '獲得轉贈點數' :
                                                                (v.TransactionType === 'U1') ? '商城-消費累點' :
                                                                (v.TransactionType === 'U2') ? '商城-退貨扣點' :
                                                                (v.TransactionType === 'U4') ? '商城-消費折抵' :
                                                                (v.TransactionType === 'U5') ? '商城-商品點數折抵' :
                                                                (v.TransactionType === 'U6') ? '商城-訂單取消返還' : ''
                                                            }}
                                                            <span v-if="v.TransactionType === 'C1'"><br>{{v.GiftName}}X{{v.Count}}</span>
                                                        </td>
                                                        <td>{{ v.TransactionAt|formatDate }}</td>
                                                        <td>{{ v.StoreName }}</td>
                                                        <td>{{ v.TransactionAmount }}</td>
                                                        <td>{{ v.Bonus }}</td>
                                                        <td>{{ v.TotalBonus }}</td>
                                                    </tr>
                                                </template>
                                            </tbody>
                                        </table>
                                    </div>
                                    <div class="row" style="padding: 0 1rem">
                                        <b-pagination
                                          size="md"
                                          :total-rows="totalRowsComputed"
                                          v-model="model.currentPage"
                                          :per-page="model.rows"
                                          @change="getmembertransaction">
                                        </b-pagination>
                                        <label style="margin:8px">
                                            {{ startRowComputed }}到{{ endRowComputed }}，總共 {{ totalRowsComputed }}筆
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </b-card>
                </div>
            </div>
            <!-- second row ends here -->
            <!-- Fourth Basic Table Starts Here-->
        </div>
    </div>
</template>
<script>
import Vue from 'vue'
import VueForm from 'vue-form'
import options from 'validations'
import axios from 'axios'
import {API_URL} from '../../../store/root.js'
import miniToastr from 'mini-toastr'
import { getFunctionPermission } from '@/js/LoginUserFunction.js'
Vue.use(VueForm, options)
export default {
  name: 'add_user',
  data () {
    return {
      hasSearched: false,
      appliedTypes: '0', // 查詢真正生效的 types
      transactionTypeMergeCode: ['T4', 'T6'],
      transactionTypeMergeOption: { Code: 'PosRedeemMerge', Text: '線下-點抵金' },
      formstate: {},
      selectListBrands: [], // 品牌下拉選單
      transactiontypelist: [],
      sdateInvalid: false,
      edateInvalid: false,
      model: {
        sdate: '',
        edate: '',
        types: '0',
        TotalPoint: 0,
        currentPage: 1,
        rows: 20,
        count: 0,
        startRowNum: 0,
        endRowNum: 0,
        queryBrandsCode: ''// 下拉選單預設為後端brands.go檔案定義的"全部"
      },
      Datalist: [],
      old_file: ''
    }
  },
  watch: {
    'model.types'(val) {
      // 改選項時只重置頁碼
      this.model.currentPage = 1
    }
  },
  computed: {
    brandMap () {
      const m = {}
      for (const it of this.selectListBrands || []) {
        // 略過「全部」(Code 可能為空字串)
        if (it && it.Code) {
          m[it.Code] = it.Text
        }
      }
      return m
    },
    typesToSend () {
      return (this.appliedTypes === this.transactionTypeMergeOption.Code) ? 'T4,T6' : this.appliedTypes
    },
    isMergedSelected () {
      return this.appliedTypes === this.transactionTypeMergeOption.Code
    },
    preholdRows () { // T4 預扣（當頁）
      return this.isMergedSelected ? this.Datalist.filter(x => x.TransactionType === 'T4') : []
    },
    confirmRows () { // T6 確認（當頁）
      return this.isMergedSelected ? this.Datalist.filter(x => x.TransactionType === 'T6') : []
    },
    totalRowsComputed () { // 拿不到後端 count, 就交由前端計算 row
      const cnt = Number(this.model.count || 0)
      return cnt > 0 ? cnt : (Array.isArray(this.Datalist) ? this.Datalist.length : 0)
    },
    startRowComputed () {
      const total = this.totalRowsComputed
      if (total === 0) return 0
      const start = (Number(this.model.currentPage) - 1) * Number(this.model.rows) + 1
      return start > total ? total : start
    },
    endRowComputed () {
      const total = this.totalRowsComputed
      if (total === 0) return 0
      const end = Number(this.model.currentPage) * Number(this.model.rows)
      return end > total ? total : end
    },
    pagedRows () { return this.Datalist },
    /*
    範例:
      [
        { Code: 'T1', Name: '線上-加點' },
        { Code: 'PosRedeemMerge', Name: '線下-點抵金' }, // 插入合併選項
        { Code: 'T2', Name: '線上-折抵' },
        { Code: 'T3', Name: '其他' }
      ]
    */
    mergedTransactionTypes () {
      // 去重
      const codes = new Set(this.transactionTypeMergeCode)
      const list = this.transactiontypelist || []

      // 找出所有需要合併的項目
      const mergeItems = list.filter(t => codes.has(t.Code))
      const others = list.filter(t => !codes.has(t.Code))

      if (mergeItems.length === 0) return list

      // 找出第一個合併項目的原始位置
      const firstMergeIndex = list.findIndex(t => codes.has(t.Code))

      // 在移除項目後的正確位置插入合併選項
      const result = [...others]
      const insertIndex = Math.min(firstMergeIndex, result.length)
      result.splice(insertIndex, 0, this.transactionTypeMergeOption)

      return result
    }
  },
  methods: {
    brandName (code) {
      return this.brandMap[code] || code || ''
    },
    changeDate (e, type) {
      // 日期變更事件
      if (type === 1) {
        this.sdateInvalid = e.target.validity.badInput
      } else {
        this.edateInvalid = e.target.validity.badInput
      }
    },
    keydownDate (e, type) {
      // 日期輸入事件
      if (type === 1) {
        this.sdateInvalid = e.target.validity.badInput
      } else {
        this.edateInvalid = e.target.validity.badInput
      }
    },
    async getmembertransaction (currentPage) {
      if (this.$route.params.memberid === undefined) {
        this.$router.push({ name: 'member_info_list' })
        return
      }

      const edate = this.model.edate || '9999-12-31'
      if (this.model.sdate > edate) {
        miniToastr.error('請選擇正確的累點時間區間')
        return
      }

      this.$parent.Loading = true

      // 線下點抵金 合併模式 → 一次打 T4,T6
      const typesToSend = this.typesToSend

      try {
        const { data } = await axios.post(
          API_URL + '/web/getmember/transaction/histories/v1', {
          memberid: this.$route.params.memberid,
          brand: this.model.queryBrandsCode,
          types: this.typesToSend,
          startdate: this.model.sdate,
          enddate: edate,
          page: currentPage,
          rows: this.model.rows
        })

        if (data.result === '0000') {
          this.model.count = Number(data.count || 0)
          this.model.TotalPoint = data.usablebonus
          this.Datalist = data.membertransactionlist || []
          this.model.currentPage = currentPage
          this.$store.commit('TOKEN', data.jwt)
        } else if (data.result === '0006') {
          this.$parent.logOut(true, true)
        } else {
          miniToastr.error(data.message, '查詢失敗')
          console.log(data.message)
        }
      } catch (error) {
        console.log('CATCH', error)
        miniToastr.error('查詢失敗', '錯誤')
      } finally {
        this.$parent.Loading = false
      }
    },
    setdate () {
      var date = new Date()
      date.setMonth(date.getMonth() - 3)
      var year = date.getFullYear()
      var mon = date.getMonth() + 1
      var day = date.getDate()

      if (mon < 10) {
        mon = '0' + mon
      }
      if (day < 10) {
        day = '0' + day
      }
      this.model.sdate = year + '-' + mon + '-' + day
      this.model.edate = ''
    },
    datevalidationcheck (str) {
      var re = new RegExp('^([0-9]{4})[.-]{1}([0-9]{1,2})[.-]{1}([0-9]{1,2})$')
      var strDataValue
      var infoValidation = true
      if ((strDataValue = re.exec(str)) != null) {
        var i
        i = parseFloat(strDataValue[1])
        if (i <= 0 || i > 9999) {
          infoValidation = false
        }
        i = parseFloat(strDataValue[2])
        if (i <= 0 || i > 12) {
          infoValidation = false
        }
        i = parseFloat(strDataValue[3])
        if (i <= 0 || i > 31) {
          infoValidation = false
        }
      } else {
        infoValidation = false
      }
      return infoValidation
    },
    reset () {
      this.model.types = '0'
      this.appliedTypes = '0'
      this.model.searchtext = ''
      this.setdate()
      this.model.currentPage = 1
      this.sdateInvalid = false
      this.edateInvalid = false
      this.getmembertransaction(1)
    },
    search () {
      // 檢查開始日期
      if (this.model.sdate && !this.datevalidationcheck(this.model.sdate)) {
        miniToastr.error('開始日期格式錯誤')
        return
      }

      // 檢查結束日期
      if (this.model.edate && !this.datevalidationcheck(this.model.edate)) {
        miniToastr.error('結束日期格式錯誤')
        return
      }

      // 檢查日期區間
      if (this.model.sdate && this.model.edate && this.model.sdate > this.model.edate) {
        miniToastr.error('查詢日期區間錯誤，請重新輸入')
        return
      }

      // 使用者目前的選擇，再打 API
      this.appliedTypes = this.model.types
      this.model.currentPage = 1
      this.getmembertransaction(1)
    },
    gettransactiontype () {
      this.$parent.Loading = true
      return axios.post(API_URL + '/web/transactiontype/v1', {
      })
        .then((response) => {
          if (response.data.result === '0000') {
            this.transactiontypelist = response.data.transactiontype
          } else if (response.data.result === '0006') {
            this.$parent.logOut(true, true)
          } else {
            miniToastr.error(response.data.message, '點數類別讀取失敗')
            console.log(response.data.message)
          }
          this.$parent.Loading = false
        })
        .catch((error) => {
          console.log('CATCH')
          console.log(error)
          this.$parent.Loading = false
        })
    },
    querySelectListBrands() {
      axios.post(API_URL + "/web/brands/v1", {
        all: true,
        order: true
      })

      .then(response => {
        this.selectListBrands = response.data.data || [];
        this.$parent.Loading = false;
        })

      .catch(error => {
        this.selectListBrands = [];
        this.$parent.Loading = false;
        miniToastr.error(error, "資料讀取異常");
        console.log(error);
      })
    }
  },
  mounted: function () {

  },
  destroyed: function () {
  },
  beforeMount: function () {
    // 讓第一次載入時 computed 就有正確值
    this.appliedTypes = this.model.types
    this.gettransactiontype()
    this.setdate()
    this.getmembertransaction(1)
    this.querySelectListBrands()
  },
  filters: {
    formatDate: function (date) {
      var d = new Date(date)
      var year = d.getFullYear()
      var month = d.getMonth() + 1
      var day = d.getDate() < 10 ? '0' + d.getDate() : '' + d.getDate()
      var hour = d.getHours() < 10 ? '0' + d.getHours() : '' + d.getHours()
      var minutes = d.getMinutes() < 10 ? '0' + d.getMinutes() : '' + d.getMinutes()
      var seconds = d.getSeconds() < 10 ? '0' + d.getSeconds() : '' + d.getSeconds()
      if (month < 10) {
        month = '0' + month
      }
      return year + '/' + month + '/' + day + ' ' + hour + ':' + minutes + ':' + seconds
    }
  },
  created () {
    this.FunctionPermission = getFunctionPermission('F07') // 功能權限 帶入功能代碼
    if (this.FunctionPermission < 1) {
      this.$router.push({name: 'name'})
    }
  }
}
</script>
<style scoped>
    .box-shadow {
        box-shadow: 0px 0px 1px 1px #cfcfcf;
    }
</style>



// WEBPACK FOOTER //
// src/pages/member/info/BonusHistory.vue